import type { ICalculatorState } from "../types/state.types"

export class CalculatorStateClass implements ICalculatorState {
    isProcessed = false
    isFailed = false
    data = null
    inputData = null
    manualEligibilityData = null
}
